export default {
  mainDescription: {
    id: 'bo_seller_profile_page_tax_residence_main_description',
    defaultMessage:
      'Add the country of your tax residence. We’ll use this information for tax and legal purposes.',
  },
  secondaryDescription: {
    id: 'bo_seller_profile_page_tax_residence_secondary_description',
    defaultMessage:
      'Do you have permanent establishments in other countries in the EU? Add them here. What qualifies as another permanent establishment?',
  },
  mainTitle: {
    id: 'bo_seller_profile_page_tax_residence_main_title',
    defaultMessage: 'Country of tax residence',
  },
  secondaryTitle: {
    id: 'bo_seller_profile_page_tax_residence_secondary_title',
    defaultMessage: 'Other permanent establishments in the European Union (EU)',
  },
  toDoLabel: {
    id: 'bo_seller_profile_page_tax_residence_todo_label',
    defaultMessage: 'To do',
  },
  helpLinkText: {
    id: 'bo_seller_profile_page_tax_residence_help_link_text',
    defaultMessage: 'Read this article to learn more',
  },
  helpLinkUrl: {
    id: 'bo_seller_profile_page_tax_residence_help_link_url',
    defaultMessage:
      'https://backmarket.my.site.com/ssc/s/article/Whats-the-DAC7-directive',
  },
  editButton: {
    id: 'bo_seller_profile_page_tax_residence_edit_button',
    defaultMessage: 'Edit',
  },
  addEstablishmentsButton: {
    id: 'bo_seller_profile_page_tax_residence_add_establishments_button',
    defaultMessage: 'Add establishments',
  },
  addCountry: {
    id: 'bo_seller_profile_page_tax_residence_add_country',
    defaultMessage: 'Add country',
  },
}
